export default __webpack_public_path__ + "static/media/2.ec975e5e.jpg";